import { Product_SkuColor, Product_SkuSize } from '@proto/store/api/store/product';

export class Skus {
  constructor(
    public productId: string,
    public colorId: string,
    public sizeId: string
  ) {}

  static skuId(productId: string, colorId: string, sizeId: string): string {
    if (productId && colorId && sizeId) {
      return `${productId}${colorId}${sizeId}0`;
    }
    if (productId && colorId) {
      return `${productId}${colorId}`;
    }
    return productId;
  }

  static fromId(skuId: string): Skus {
    if (skuId.length < 8) {
      return new Skus(skuId.substring(0, 5), skuId.substring(5, 7), '');
    }
    if (skuId.length > 8) {
      skuId = skuId.substring(0, 8);
    }
    return new Skus(
      skuId.substring(0, skuId.length - 3),
      skuId.substring(skuId.length - 3, skuId.length - 1),
      skuId.substring(skuId.length - 1)
    );
  }

  static getImage220(color: Product_SkuColor | undefined, curSize?: Product_SkuSize | undefined): string {
    return (curSize?.isExtension && !!color?.extImage?.img220 ? color.extImage?.img220 : color?.image?.img220) ?? '';
  }

  static getImage500(color: Product_SkuColor | undefined, curSize?: Product_SkuSize | undefined): string {
    return (curSize?.isExtension && !!color?.extImage?.img500 ? color.extImage?.img500 : color?.image?.img500) ?? '';
  }

  static getImage1500(color: Product_SkuColor | undefined, curSize?: Product_SkuSize | undefined): string {
    return (curSize?.isExtension && !!color?.extImage?.img1500 ? color.extImage?.img1500 : color?.image?.img1500) ?? '';
  }
}
